import styled from 'styled-components';

export const HeaderWrapper = styled.div`
	border-bottom: 1px solid #eee;
	height: 80px;
	/* display: flex; */
	align-items: center;
	position: relative;
	z-index: 100;
	background-color: #fff;
	position: fixed;
	width: 100%;
	top: 0;
	display: ${(props) => (props.display ? props.display : `flex`)};

	.mo-header {
		display: none;
	}

	.wrapper {
		/* max-width: 1480px;
		width: 100%;
		margin: 0 auto;
		padding: 0 20px; */
		width: 100%;
	}
	.flex {
		display: flex;
		justify-content: space-between;
		align-items: center;
		max-width: 1480px;
		width: 100%;
		margin: 0 auto;
		padding: 0 20px;
		.logo {
			width: 158px;
			img {
				width: 100%;
			}
		}
		.right-box {
			display: flex;
			gap: 38px;
			align-items: center;
			.gnb {
				display: flex;
				align-items: center;
				gap: 38px;
				position: relative;
				left: 10px;
				li {
					font-size: 15px;
					font-weight: 400;
					line-height: 100%;
					transition: all 0.3s;
					padding: 8px 10px;

					&:hover {
						border-radius: 6px;
						background: rgba(0, 0, 0, 0.03);
					}
				}
				.branding {
					border-radius: 6px;
					background: rgba(0, 0, 0, 0.03);
					padding: 7px 10px 8px 10px;
				}
			}
			.search {
				cursor: pointer;
			}
			.icon-box {
				margin-left: 38px;
				display: flex;
				align-items: center;
				gap: 34px;
				.arrow {
					border-radius: 35px;
					background: rgba(0, 0, 0, 0.03);
					width: 28px;
					height: 28px;
					transition: width 0.3s;
					position: relative;
					overflow: hidden;
					cursor: pointer;
					&:hover {
						width: 204px;
						img {
							left: 93%;
							/* opacity: 0; */
						}
						.arrow-text {
							opacity: 1;
						}
					}
					img {
						position: absolute;
						top: 50%;
						left: 50%;
						transform: translate(-50%, -50%);
						transition: left 0.3s, opacity 0.3s;
					}
					.arrow-text {
						position: absolute;
						top: 50%;
						left: 0;
						transform: translateY(-50%);
						white-space: nowrap;
						display: flex;
						gap: 16px;

						font-size: 13px;
						font-weight: 400;
						line-height: normal;
						opacity: 0;
						padding: 6px 12px;
						a {
							color: #999;
							position: relative;
							&::after {
								position: absolute;
								content: '';
								width: 1px;
								height: 8px;
								background-color: #ddd;
								top: 50%;
								transform: translateY(-50%);
								right: -8px;
							}
							&:last-child {
								&::after {
									display: none;
								}
							}
						}
					}
				}

				.search {
					img {
						cursor: pointer;
					}
				}
			}
		}
	}
	.overlay {
		display: none;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.35);
		position: fixed;
		top: 58px;
		left: 0;
		z-index: 99;
	}
	.overlay.active {
		display: block;
	}
	.toggle {
		transition: 0.5s;
		position: absolute;
		display: block;
		top: 0;
		width: 100%;
		transform: translateY(-100%);
		background-color: #fff;
		z-index: 200;
		&.open {
			transform: translateY(0);
		}
		.dropdown {
			width: 100%;
			/* position: absolute; */
			z-index: 10;
			top: -56px;
			left: 0;
			background: #fff;
			transition: all 0.3s;
			padding-bottom: 60px;

			.toggle-wrap {
				max-width: 1440px;
				width: 100%;
				margin: 0 auto;

				.close-btn {
					height: 74px;
					display: flex;
					justify-content: end;
					align-items: center;
					transition: all 0.2s;

					img {
						cursor: pointer;

						&:hover {
							opacity: 0.8;
						}
					}
				}
				.inner {
					max-width: 760px;
					width: 100%;
					margin: 0 auto;
				}
				.input-box {
					max-width: 760px;
					position: relative;
					img {
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 17px;
						cursor: pointer;
					}
					input {
						width: 100%;
						border: none;
						border-radius: 10px;
						background: #f7f7f7;
						padding: 13px 46px 12px 46px;
						font-size: 14px;
						font-weight: 400;
						line-height: 150%;
						&::placeholder {
							color: #999;
						}
					}
				}
				.tag-box {
					margin-top: 30px;
					margin-left: 10px;
					h3 {
						font-size: 14px;
						font-weight: 700;
						line-height: 150%;
					}
					.tag {
						display: flex;
						gap: 14px;
						margin-top: 7px;
						li {
							color: #e99210;
							font-size: 14px;
							font-weight: 300;
							line-height: 150%;
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 768px) {
		height: 58px;
		background-color: #fff;
		z-index: 200;
		position: fixed;
		width: 100%;
		top: 0;
		.pc-header {
			display: none;
		}
		.mo-header {
			display: flex;
			justify-content: space-between;
			width: 100%;
			padding: 0 16px 0 20px;
			position: relative;
			z-index: 150;

			.logo {
				width: 112px;
				position: relative;
				top: 3px;
				img {
					width: 100%;
				}
			}

			.icon-box {
				display: flex;
				gap: 17px;

				.ham {
					padding: 4px;
				}
			}
		}
	}
	/* .toggle {
			transition: all 0.2s;
			position: relative;
			top: -1000px;
			width: 100%;
			&.open {
				position: relative;
				top: 0;
			} */
	.toggle {
		top: -100px;
		width: 100%;
		height: 174px;
		&.open {
			top: 40px;
		}
		.dropdown {
			width: 100%;
			position: absolute;
			z-index: 100;
			top: -40px;
			left: 0;
			background: #fff;
			transition: all 0.3s;
			padding: 0 20px 50px 20px;
			.toggle-wrap {
				.close-btn {
					height: 80px;
					display: flex;
					justify-content: end;
					align-items: center;
					transition: all 0.2s;
					img {
						cursor: pointer;
						opacity: 0.8;
					}
				}
				.input-box {
					max-width: 100%;
					position: relative;
					top: -15px;
					img {
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 17px;
						cursor: pointer;
					}
					input {
						width: 100%;
						border: none;
						border-radius: 10px;
						background: #f7f7f7;
						padding: 13px 46px 12px 46px;
						font-size: 14px;
						font-weight: 400;
						line-height: 150%;
						&::placeholder {
							color: #999;
						}
					}
				}
				.tag-box {
					margin-top: 18px;
					h3 {
						font-size: 14px;
						font-weight: 700;
						line-height: 150%;
					}
					.tag {
						display: flex;
						gap: 14px;
						li {
							color: #e99210;
							font-size: 14px;
							font-weight: 300;
							line-height: 150%;
						}
					}
				}
			}
		}
	}

	.ham-toggle {
		transition: all 0.5s;
		/* position: relative;
			top: -58px;
			width: 100%; */
		position: absolute;
		top: 0px;
		width: 100%;
		transform: translateY(-100%);
		background-color: #fff;
		z-index: 100;
		/* height: 140px; */

		&.open {
			/* position: relative;
				top: 0px; */
			transform: translateY(0);
			top: 58px;
		}
		.overlay {
			width: 100%;
			height: 100vh;
			background: rgba(0, 0, 0, 0.35);
			position: fixed;
			top: 58px;
			left: 0;
			z-index: 99;
			display: none;
		}
		.overlay.active {
			display: block;
		}

		.dropdown {
			width: 100%;
			position: absolute;
			z-index: 100;
			top: -2px;
			left: 0;
			background: #fff;
			transition: all 0.2s;
			padding: 43px 20px 12px 20px;

			.toggle-wrap {
				p {
					font-size: 18px;
					font-weight: 400;
					line-height: 100%;
					margin-bottom: 28px;
				}
				ul {
					margin-top: 28px;
					display: flex;
					gap: 14px;
					li {
						border-radius: 60px;
						background: #f7f7f7;
						padding: 6px 12px;
						color: #999;
						font-size: 14px;
						font-weight: 400;
						line-height: normal;
						img {
							margin-left: 8px;
						}
					}
				}
			}
		}
	}
`;
